import { z } from 'zod';

export const VirtualPlatformSchema = z.object({
  value: z.string(),
  label: z.string(),
  iconUrl: z.string().nullable(),
  isInUse: z.boolean(),
  suggestionEmailsCount: z.number(),
});

export const VirtualPlatformsSummarySchema = z.object({
  inUseAmount: z.number(),
  activatedAmount: z.number(),
});

export const VirtualPlatformsResponseSchema = z.object({
  data: z
    .object({
      items: z.array(VirtualPlatformSchema),
    })
    .nullable(),
  meta: z
    .object({
      summary: VirtualPlatformsSummarySchema,
    })
    .nullable(),
  error: z.object({ message: z.string() }).nullable(),
});

export type VirtualPlatform = z.infer<typeof VirtualPlatformSchema>;
export type VirtualPlatformsSummary = z.infer<
  typeof VirtualPlatformsSummarySchema
>;
